export const NAVIGATION_CONFIG = [
  {
    title: 'Allgemein',
    items: [
      {label: 'Dashboard', path: '/dashboard', requiresProfile: true},
      {label: 'Profil', path: '/profile'},
      {label: 'Account', path: '/account'},
      {label: 'Einstellungen', path: '/settings'},
      {label: 'Rollen & Rechte', path: '/admin/roles', requiresRoleAdmin: true},
      {label: 'DevOps', path: '/devops', requiresRoleAdmin: true},
    ],
  },
  {
    title: 'Vertrieb',
    collapsible: true,
    items: [
      {label: 'Artikel', path: '/article', requiresProfile: true},
      {label: 'Versandkosten', path: '/shipping-costs', requiresProfile: true},
      {label: 'Kunden', path: '/customer', requiresProfile: true},
      {label: 'Aufträge', path: '/orders', requiresProfile: true},
      {label: 'Angebote', path: '/offers', requiresProfile: true},
      {label: 'Rechnungen', path: '/invoices', requiresProfile: true},
      {label: 'Offene Posten', path: '/open-invoices', requiresProfile: true},
      {label: 'Abo-Rechnungen', path: '/recurring-invoices', requiresProfile: true},
    ],
  },
  {
    title: 'Buchhaltung',
    collapsible: true,
    items: [
      {
        label: 'Zahlungsvorgänge',
        path: '/payments',
        requiresAccounting: true,
        requiresProfile: true,
        children: [
          {
            label: 'Einnahmen',
            path: '/payments?tab=incomes',
            requiresAccounting: true,
            requiresProfile: true,
          },
          {
            label: 'Ausgaben',
            path: '/payments?tab=expenses',
            requiresAccounting: true,
            requiresProfile: true,
          },
        ],
      },
      {
        label: 'Lieferanten',
        path: '/suppliers',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'Anlagegüter',
        path: '/assets',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'Anlagenspiegel',
        path: '/asset-report',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'BWA & GuV / EÜR',
        path: '/financial-report',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'Liquiditätsprognose',
        path: '/cashflow',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'Lohn & Mitarbeiter',
        path: '/payroll',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'Steuerliche Auswertung',
        path: '/evaluation',
        requiresAccounting: true,
        requiresProfile: true,
      },
      {
        label: 'Buchhaltungsfunktionen freischalten (20 € netto)',
        path: '/registration',
        requiresProfile: true,
        showWhen: (meta) => !meta.hasAccounting,
      },
    ],
  },
];
